<template>
  <router-link to="/" custom v-slot="{ navigate }">
    <a :href="GetEMPFontendURL" target="_blank"> <!-- @click="navigate($event)" -->
      <img loading="lazy" :src="LogoPath" class="img-fluid" style="padding: 12px 24px;" alt="CPS+ eMarketplace" />
    </a>
  </router-link>
</template>
<script>

export default {
  computed: {
    langid() {
      return localStorage.getItem("currentLangId");
    },
    GetEMPFontendURL(){
       const lang = localStorage.getItem('currentLang') || 'simp';
        const base =process.env.VUE_APP_EMP_VIEW;
      return `${base}${lang}`;
    }, 
    LogoPath() {
      const locale =
        this.langid == "936" ? "sc" : this.langid == "950" ? "tc" : "en";
      const logoEndPoint = `/EMP_logos_${locale}.png?x-oss-process=image/format,webp`; 
      return "https://cdn.adsalecdn.com/EMP/2-0/images" + logoEndPoint;
    },
  },
  name: "Logo",
};
</script>
